import React from "react";

import { getServiceRouteDepartureTime, getServiceRouteArrivalTime } from "./serviceRouteListTimes";

const ServiceRouteTimeCell = ({ row, kind }) => {
  const time = kind === "departure" ? getServiceRouteDepartureTime(row) : getServiceRouteArrivalTime(row);

  return (
    <span
      style={{
        color: time ? "#33475b" : "#95a5a6",
        fontSize: "13px",
        fontWeight: time ? 600 : 400,
        lineHeight: 1.6,
      }}
    >
      {time || "—"}
    </span>
  );
};

export default ServiceRouteTimeCell;
